import { useMutation } from 'react-query'
import userFacilitatorRatingApi from '../../services/api/user-facilitator-rating'
import useStaleTimes from '../use-stale-times'
import useCacheKeys from '../use-cache-keys'
import useCache from '../use-cache'
import moment from 'moment'

const useUserFacilitatorRatingMutations = ({
    onSuccess = () => {},
    onError = () => {},
    userId,
    ratingId,
    rating,
    feedback,
} = {}) => {
    const staleTimes = useStaleTimes()
    const cacheKeys = useCacheKeys()
    const {
        clearCache
    } = useCache({
        key: cacheKeys.SURVEYS,
        onReload: onSuccess
    })
    const [
        updateFacilitatorRating,
        { isLoading }
    ] = useMutation(() => userFacilitatorRatingApi.update({ userId, ratingId, rating, feedback }), { 
        onSuccess: clearCache,
        onError,
    })

    return {
        updateFacilitatorRating,
        isUpdating: isLoading,
    }
}

export default useUserFacilitatorRatingMutations